import React from 'react';

export default () => (
  <svg
    height="14px"
    version="1.1"
    viewBox="0 0 14 14"
    width="14px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>Cancel job</title>
    <desc>Cancel job icon</desc>
    <g
      fill="none"
      fillRule="evenodd"
      id="stop-14x14"
      stroke="none"
      strokeWidth="1.5"
    >
      <path
        d="M10.3798608,2.47318504 L2.89657733,10.5359473 C2.14491078,11.3927279 3.14748723,12.4773331 3.89915377,11.6205525 L11.3824372,3.55779022 C12.1341038,2.70100964 11.1315273,1.61640447 10.3798608,2.47318504 Z"
        fill="#000000"
        fillRule="nonzero"
      />
      <circle
        cx="7"
        cy="7"
        id="Oval"
        r="6"
        stroke="#000000"
        strokeWidth="1.5"
      />
    </g>
  </svg>
);
